import Button from '@/components/common/Button';
import {GENERAL_STATUS_STYLE} from "@/constant/status";

const NEWS_STATUS = ['PUBLISHED', 'DRAFT', 'ARCHIVED'];

const Header = ({ handleClick, form }) => {
	const { register, watch } = form
	const newsStatus = watch('newsStatus')

	return (
		<div className="flex">
			<div className="mr-4">
				<select
					className={`color-select h-full ${GENERAL_STATUS_STYLE[newsStatus]}`}
					{...register('newsStatus')}
				>
					{
						NEWS_STATUS.map(i =>
							<option
								key={i}
								value={i}
								className={GENERAL_STATUS_STYLE[i]}
							>
								{i}
							</option>
						)
					}
				</select>
			</div>

			<Button variant="primary" type={null} onClick={handleClick}>
				Submit
			</Button>
		</div>
	)
};

export default Header;
